/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-12-07 11:24:24
 * @LastEditors: xgx
 * @LastEditTime: 2022-12-07 11:47:26
 */
export default {
    install (Vue) {
      // 防重复点击(指令实现)
      Vue.directive('repeatClick', {
        inserted (el, binding) {
          el.addEventListener('click', () => {
            console.log(!el.disabled,'xxx');
            if (!el.disabled) {
              el.disabled = true
              setTimeout(() => {
                el.disabled = false
              }, binding.value || 2000)
            }
          })
        }
      })
    }
  }